import Store from "../store";
import scrollToEl from "./scrollToEl";

const scrollToReacFormError = (formData, fields) => {
    const { ui } = Store.getState();

    const errorField = fields.find(field => !field.valid);
    if (errorField && errorField.ref && errorField.ref.current) {
        scrollToEl(errorField.ref.current, 300, -(ui.navHeight + 40));
    }
};

export default scrollToReacFormError;
